import { Link, useMatchRoute } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";
import type * as React from "react";

import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@/components/ui/sidebar";

/**
 * Icon component type that supports optional animateOnHover prop
 */
type IconComponent = LucideIcon | React.ComponentType<{ animateOnHover?: boolean }>;

export function NavSecondary({
	items,
	...props
}: {
	items: {
		title: string;
		url: string;
		icon: IconComponent;
		onClick?: (e: React.MouseEvent) => void;
	}[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
	const matchRoute = useMatchRoute();

	return (
		<SidebarGroup {...props}>
			<SidebarGroupContent>
				<SidebarMenu>
					{items.map((item) => {
						const isActive = item.onClick ? false : !!matchRoute({ to: item.url });
						return (
							<SidebarMenuItem key={item.title}>
								{item.onClick ? (
									<SidebarMenuButton onClick={item.onClick}>
										<item.icon />
										<span>{item.title}</span>
									</SidebarMenuButton>
								) : (
									<SidebarMenuButton isActive={isActive} asChild>
										<Link to={item.url}>
											<item.icon />
											<span>{item.title}</span>
										</Link>
									</SidebarMenuButton>
								)}
							</SidebarMenuItem>
						);
					})}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	);
}
